import { memo, useContext, useState } from "react";

import classes from "./BookShelfMobile.module.css";

import RecipeBookClosed from "../../components/BookShelf/RecipeBookClosed/RecipeBookClosed";
import LoadingSpinner from "../../UI/LoadingSpinner";

import ShelfContext from "../../store/shelf-context";

// Page where user books can be accessed, formatted for mobile
const BookShelfMobile = () => {
  const shelfCtx = useContext(ShelfContext);
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  // set x and y coordinates where books should sit on the bookshelf
  const book_x_position = [
    1, 13, 25, 37, 76, 88, 1, 13, 25, 37, 49, 61, 73, 85, 97,
  ];
  const book_y_position = [6, 6, 6, 6, 6, 6, 56, 56, 56, 56, 56, 56, 56];

  // set the x and y coordinates of the book objects
  const books = shelfCtx.books.map((book, index) => {
    const posX = book_x_position[index].toString().concat("vw");
    const posY = book_y_position[index].toString().concat("vw");

    console.log(book._id);

    return (
      <RecipeBookClosed
        key={index}
        book={book}
        number={index}
        posX={posX}
        posY={posY}
      />
    );
  });

  return (
    <div className={classes.BookShelf}>
      {isLoading && <LoadingSpinner asOverlay />}
      <img
        className={classes.full_shelf}
        src={"/assets/gen_graphics/bookshelf_full_1.png"}
        alt="new"
      />
      <div className={classes.empty_shelf_container}>
        <img
          className={classes.empty_shelf_img}
          src={"/assets/gen_graphics/book_shelf_empty.svg"}
          alt="new"
          onLoad={handleImageLoad}
        />
        <div className={classes.shelf}>{books}</div>
      </div>
      <img
        className={classes.full_shelf}
        src={"/assets/gen_graphics/bookshelf_full_1.png"}
        alt="new"
      />
    </div>
  );
};

export default memo(BookShelfMobile);
